import { wait } from '../common'
import Uppy from '@uppy/core'
import DragDrop from '@uppy/drag-drop'
import XHRUpload from '@uppy/xhr-upload'
import ProgressBar from '@uppy/progress-bar'

const form = document.querySelector('.vp-block-form-register-shareholder')
const ajaxWait = 200
let errorMessage = ''
let dom = {}

if (form) {
    dom = {
        fields: form.querySelector('.fields'),
        fieldItems: form.querySelectorAll('vp-field'),
        process: form.querySelector('.process'),
        message: form.querySelector('.message'),
        sent: form.querySelector('.sent'),

        shareholder: form.querySelector('vp-field[name="shareholder"]'),
        civility: form.querySelector('vp-field[name="civility"]'),
        lastname: form.querySelector('vp-field[name="lastname"] input'),
        firstname: form.querySelector('vp-field[name="firstname"] input'),
        email: form.querySelector('vp-field[name="email"] input'),
        tel: form.querySelector('vp-field[name="tel"] input'),
        address: form.querySelector('vp-field[name="address"] input'),
        city: form.querySelector('vp-field[name="city"] input'),
        zip: form.querySelector('vp-field[name="zip"] input'),
        year_of_birth: form.querySelector('vp-field[name="year_of_birth"] input'),
        user_login: form.querySelector('vp-field[name="user_login"] input'),
        user_pass: form.querySelector('vp-field[name="user_pass"] input'),
        pass_confirm: form.querySelector('vp-field[name="pass_confirm"] input'),
        shareholder_since: form.querySelector('vp-field[name="shareholder_since"] input'),
        shares_number: form.querySelector('vp-field[name="shares_number"] input'),
        file: form.querySelector('vp-field[name="file"]'),
        dropzone: form.querySelector('.dropzone'),
        uploadMessage: form.querySelector('.upload-message'),
        uploadOk: form.querySelector('.upload-ok'),
        uploadFile: form.querySelector('.upload-file'),
        uploadDelete: form.querySelector('.upload-delete'),
        rgpd: form.querySelector('#rgpd'),
    }

    dom.process.addEventListener('click', send)

    // upload
    const uppy = new Uppy({
        id: 'uppy',
        autoProceed: true,
        restrictions: {
            maxFileSize: 6291456,
            maxNumberOfFiles: 1,
            allowedFileTypes: [
                'application/msword',
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/pdf',
            ],
        },
        onBeforeUpload: () => {
            dom.uploadMessage.innerHTML = ''
        },
        debug: false,
    })
        .use(DragDrop, {
            target: dom.dropzone,
            note: dom.dropzone.dataset.uppyNote,
            locale: {
                strings: {
                    dropHereOr: dom.dropzone.dataset.uppyLabel,
                    browse: dom.dropzone.dataset.uppyBrowse,
                },
            },
        })
        .use(XHRUpload, {
            endpoint: dom.dropzone.dataset.url,
            formData: true,
        })
        .use(ProgressBar, {
            target: dom.dropzone,
            fixed: false,
            hideAfterFinish: true,
        })

    uppy.setMeta({
        nonce: dom.dropzone.dataset.nonce,
        action: dom.dropzone.dataset.action,
    })
    uppy.on('upload-success', (file, response) => {
        // console.log(response.body.data)
        const name = response.body.data
        dom.file.setAttribute('value', name)
        dom.uploadFile.innerHTML = name
        dom.uploadOk.classList.remove('hidden')
        dom.dropzone.classList.add('hidden')
        dom.uploadMessage.innerHTML = ''
    })
    uppy.on('upload-error', (file, error, response) => {
        // console.log(error)
        uppy.removeFile(file.id)
        dom.uploadMessage.innerHTML = dom.dropzone.dataset.error + `<br>(${response.body.data})`
    })
    uppy.on('error', (error) => {
        // console.error(error)
        dom.uploadMessage.innerHTML = dom.dropzone.dataset.invalid
    })
    dom.uploadDelete.addEventListener('click', () => {
        uppy.getFiles().map((file) => {
            uppy.removeFile(file.id)
        })
        dom.file.setAttribute('value', '')
        dom.uploadFile.innerHTML = ''
        dom.uploadOk.classList.add('hidden')
        dom.dropzone.classList.remove('hidden')
    })

    // init inputs
    dom.lastname.value = ''
    dom.firstname.value = ''
    dom.email.value = ''
    dom.tel.value = ''
    dom.address.value = ''
    dom.city.value = ''
    dom.zip.value = ''
    dom.year_of_birth.value = ''
    dom.user_login.value = ''
    dom.user_pass.value = ''
    dom.pass_confirm.value = ''
    dom.shareholder_since.value = ''
    dom.shares_number.value = ''
    dom.rgpd.checked = false

    // radios
    dom.shareholder.setAttribute('value', dom.shareholder.querySelector('input:checked').value)
    dom.shareholder.addEventListener('input', (e) => {
        dom.shareholder.setAttribute('value', e.target.value)
    })
    dom.civility.setAttribute('value', dom.civility.querySelector('input:checked').value)
    dom.civility.addEventListener('input', (e) => {
        dom.civility.setAttribute('value', e.target.value)
    })
}

async function send() {
    const formData = {
        nonce: form.dataset.nonce,
        action: form.dataset.action,
        shareholder: dom.shareholder.getAttribute('value'),
        civility: dom.civility.getAttribute('value'),
        lastname: dom.lastname.value,
        firstname: dom.firstname.value,
        email: dom.email.value,
        tel: dom.tel.value,
        address: dom.address.value,
        city: dom.city.value,
        zip: dom.zip.value,
        year_of_birth: dom.year_of_birth.value,
        user_login: dom.user_login.value,
        user_pass: dom.user_pass.value,
        pass_confirm: dom.pass_confirm.value,
        shareholder_since: dom.shareholder_since.value,
        shares_number: dom.shares_number.value,
        file: dom.file.getAttribute('value'),
        rgpd: dom.rgpd.checked ? 1 : 0,
    }

    // start loading
    dom.process.innerHTML = dom.process.dataset.loading
    dom.process.disabled = true
    dom.message.innerHTML = ''
    await wait(ajaxWait)

    // send
    let response
    try {
        response = await fetch(form.dataset.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(formData),
        })
    } catch (error) {
        dom.message.innerHTML = 'Network error'
        dom.process.innerHTML = dom.process.dataset.label
        dom.process.disabled = false
        return
    }

    // end loading
    dom.process.innerHTML = dom.process.dataset.label
    dom.process.disabled = false

    // http error
    if (!response.ok) {
        dom.message.innerHTML = `Error ${response.status}`
        return
    }

    // json response
    const json = await response.json()
    if (!json.success) {
        if (typeof json.data === 'string') {
            dom.message.innerHTML = json.data
        } else {
            const dataKeys = Object.keys(json.data)
            for (const field of dom.fieldItems) {
                const name = field.getAttribute('name') || ''
                if (dataKeys.includes(name)) {
                    errorMessage = json.data[name] === '1' ? true : json.data[name]
                    field.setError(errorMessage)
                } else {
                    field.removeError()
                }
            }
        }
    } else {
        dom.fields.classList.add('hidden')
        dom.sent.classList.remove('hidden')
    }
}
